'use client';

import { useGtmTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { VisitorIDSetProps, TrackingFunction } from '../types';

export const useVisitorIDTracking = (props: VisitorIDSetProps, autoTrack: boolean = false): TrackingFunction => {
  return useGtmTrack(
    {
      eventName: ANALYTICS_EVENTS.VISITOR_ID_SET,
      properties: props,
    },
    autoTrack,
  );
};
